import Hero from '../components/Hero';
import FeatureSection from '../components/FeatureSection';
import CtaSection from '../components/CtaSection';

function HomePage() {
  return (
    <>
      <Hero />
      <FeatureSection />
      <CtaSection />
    </>
  );
}

export default HomePage;
